import { render, staticRenderFns } from "./XmAddressMultiSelect.vue?vue&type=template&id=63b2031b&scoped=true"
import script from "./XmAddressMultiSelect.vue?vue&type=script&lang=js"
export * from "./XmAddressMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./XmAddressMultiSelect.vue?vue&type=style&index=0&id=63b2031b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2031b",
  null
  
)

export default component.exports